export default __webpack_public_path__ + "static/media/userRubrics.9a1999c8.svg";